module.exports = __webpack_public_path__ + "img/19.66729889.png";